import { useCallback } from 'react';
import useSWR from 'swr';
import { ReportMachine } from '../types';
import { apiClient } from '../services/apiClient';

interface UseMachineReturn {
  machine: ReportMachine | null;
  loading: boolean;
  error: Error | undefined;
  refresh: () => Promise<void>;
}

// Fetcher function for SWR
const machineFetcher = async (machineId: string): Promise<ReportMachine | null> => {
  return (await apiClient.getMachineById(machineId)) || null;
};

export const useMachine = (machineId: string | undefined): UseMachineReturn => {
  const { data, error, isLoading, mutate } = useSWR<ReportMachine | null, Error>(
    machineId ? `/api/v1/report-machines/${machineId}` : null,
    () => machineFetcher(machineId!),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  const machine = data ?? null;
  const loading = isLoading;

  const refresh = useCallback(async (): Promise<void> => {
    await mutate();
  }, [mutate]);

  return {
    machine,
    loading,
    error,
    refresh,
  };
};
